module.exports = __webpack_public_path__ + "static/media/18_tn.4e5682a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/18_tn.jpg
// module id = 654
// module chunks = 0